// extracted by mini-css-extract-plugin
export default {"ResumeContacts":"_RIJs","ResumeContacts__inner":"BIpfb","ResumeContacts__item":"t_eZc","ResumeContacts__icon":"fCfJw"};